// extracted by mini-css-extract-plugin
module.exports = {"content":"TotalWorkBox_content__2Vdnl","content__left":"TotalWorkBox_content__left__3KMzc","content__right":"TotalWorkBox_content__right__ZH5QX"};